import { render, staticRenderFns } from "./seckillCard.vue?vue&type=template&id=59c18de0&scoped=true&"
import script from "./seckillCard.vue?vue&type=script&lang=js&"
export * from "./seckillCard.vue?vue&type=script&lang=js&"
import style0 from "./seckillCard.vue?vue&type=style&index=0&id=59c18de0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c18de0",
  null
  
)

export default component.exports